import { useNavStore } from '@/stores/system/nav'
import { useUserStore } from '@/stores/system/user.ts'
import { useRouter, useRoute } from 'vue-router'
import { useModal } from 'composables/useModal.ts'

export const useRouteHistory = () => {
	const router = useRouter()
	const currentRoute = useRoute()
	const navStore = useNavStore()
	const { isLoggedIn } = useUserStore()
	const { closeModal } = useModal()

	const defaultFallbackRoute = isLoggedIn ? 'dashboard' : 'login'

	const navigateToHistoryRoute = async (
		index: number = 2,
		parent: boolean = false,
		replace: boolean = true,
		fallbackRoute: string = defaultFallbackRoute
	) => {
		let route: any = navStore.getPreviousRoute(index)
		const origin = currentRoute.query.origin
		if (origin) {
			if (currentRoute.query.modal) {
				closeModal(currentRoute.query.modal as string)
				return
			}
			const originRoute = { path: origin.toString() }
			replace
				? await router.replace(originRoute)
				: await router.push(originRoute)
			return
		}
		if (!route || parent) {
			const matched = router.currentRoute.value.matched
			if (matched.length > 1) {
				const currentRouteIndex = matched.findIndex(
					(current) => current.name === currentRoute.name
				)
				route =
					matched[
						currentRouteIndex === -1
							? matched.length - 2
							: currentRouteIndex - 1
					]
				route = router.resolve(
					{
						name: route.name,
						params: currentRoute.params,
					},
					route
				)
			} else {
				route = isLoggedIn
					? navStore.findRoute(navStore.routes, fallbackRoute)
					: { name: fallbackRoute }
			}
		}
		try {
			replace ? await router.replace(route) : await router.push(route)
		} catch (error) {
			console.error(error)
			route = { name: fallbackRoute }
			replace ? await router.replace(route) : await router.push(route)
		}
	}

	return {
		navigateToHistoryRoute,
	}
}
